export type SortOrder = 'asc' | 'desc';

export const validateOrderParameter = (order?: string): SortOrder | undefined => {
  if (order === 'asc' || order === 'desc') {
    return order;
  }

  return undefined;
};
